import { useEffect } from 'react';
import LoadingWrapper from 'components/LoadingWrapper';
import {
  fetchExamV3Mapping,
  isLoadingObjectType,
} from 'slices/appService.slice';
// Slices
import {
  examV3SettingsLoadingSelector,
  saveAllocationMode,
} from 'slices/examV3Settings.slice';
import { fetchFields, fieldsLoading } from 'slices/field.slice';
import {
  requestObjectTypes,
  selectObjectTypesLoading,
} from 'slices/objectTypes.slice';
import { useAppDispatch, useAppSelector } from 'slices/store';
import { Button, DefaultContentLayout } from '@timeedit/ui-components';
// Components
import { SeatAllocationSettings } from '../../../components/AppService/ExamV3Settings/SeatAllocationSettings';
// i18N
import intl from '../../../i18n/intl';

const language = intl.messages as Record<string, string>;

const SeatAllocationSettingsPage = () => {
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector(examV3SettingsLoadingSelector);

  useEffect(() => {
    dispatch(requestObjectTypes());
    dispatch(fetchFields());
    dispatch(fetchExamV3Mapping());
  }, [dispatch]);

  const isObjectTypesLoading = useAppSelector(selectObjectTypesLoading);
  const isExamMappingLoading = useAppSelector(isLoadingObjectType('teExamV3'));
  const isFieldsLoading = useAppSelector(fieldsLoading);

  const onSave = () => {
    dispatch(saveAllocationMode());
  };

  const loading =
    isLoading ||
    isObjectTypesLoading ||
    isExamMappingLoading ||
    isFieldsLoading;

  return (
    <DefaultContentLayout
      title={language.seat_management_settings_title}
      subtitle={language.seat_management_allocation_mode_sub_title}
      actions={
        <Button type="primary" onClick={onSave}>
          {language.save_changes as string}
        </Button>
      }
    >
      <LoadingWrapper isLoading={loading}>
        <SeatAllocationSettings isLoading={loading} />
      </LoadingWrapper>
    </DefaultContentLayout>
  );
};

export default SeatAllocationSettingsPage;
